export default __webpack_public_path__ + "static/media/ValidInputBackground.abb9567a.webp";